import { iconFactory } from '../iconFactory'

export const Clock = iconFactory(
  'Clock',
  ({ fill }) => (
    <>
      <path
        d="M7.9935 1.33301C4.3135 1.33301 1.3335 4.31967 1.3335 7.99967C1.3335 11.6797 4.3135 14.6663 7.9935 14.6663C11.6802 14.6663 14.6668 11.6797 14.6668 7.99967C14.6668 4.31967 11.6802 1.33301 7.9935 1.33301ZM8.00016 13.333C5.0535 13.333 2.66683 10.9463 2.66683 7.99967C2.66683 5.05301 5.0535 2.66634 8.00016 2.66634C10.9468 2.66634 13.3335 5.05301 13.3335 7.99967C13.3335 10.9463 10.9468 13.333 8.00016 13.333Z"
        fill={fill}
      />
      <path
        d="M8.3335 4.66699H7.3335V8.66699L10.8335 10.767L11.3335 9.94699L8.3335 8.16699V4.66699Z"
        fill={fill}
      />
    </>
  ),
  { viewBox: '0 0 16 16', height: '16px', width: '16px' },
)
